import HttpLayout from "context/HttpContext";
import LoadingLayout from "context/LoadingLayout";
import Permission from "context/Permission";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import CustomImage from "components/common/CustomImage";
import Tools from "libs/utils/Tools";
import Stats from "libs/utils/stats";

export default function Global(props : { heightClassName ?: string, children : any}){

    const [ isMobile, setIsMobile ] = useState<boolean>(() => document.body.clientWidth < 1024);

    const flag = !!Cookies.get('Authorization')
    if(!flag && !/\/edit/ig.test(location.href)){
        Tools.goLogin();
    } 

    
    const UR = Cookies.get('UR')
    if(UR){
        const statsInfo = UR.split('-');
        Stats.google('login_success', {
            method : statsInfo[0],
            user_type: statsInfo[1] == '2' ? 'new' : 'old'
        })
        Tools.removeCookie('UR')
    }

    

    const resize = () => {
        setIsMobile(document.body.clientWidth < 1024)
    }

    useEffect(() => {
        window.onresize = resize ;
    }, [])

    useEffect(() => {
        
    },[])

    return (
        <div className={`w-full ${props.heightClassName || 'h-screen'}`}> { /** w-full h-screen */}
            {
                isMobile ? 
                    <div className="flex flex-col h-[100%] items-center justify-center color-[#000000] px-[20px] text-center">
                        <CustomImage src="/icon/icon-pc.png" className="w-[120px]" />
                        <p className="text-[16px] mt-[15px]">Our app doesn't support mobile access yet.</p>
                        <p className="text-[16px] mt-[5px]">Please switch to a desktop to use our service.</p>
                        <p className="text-[16px] mt-[5px]">Thank you for your support.</p>
                    </div>
                : 
                <Permission>
                    <HttpLayout>
                        <LoadingLayout>
                            {props.children}
                        </LoadingLayout>
                    </HttpLayout>
                </Permission>
            }
        </div>
    )
}